export const GOOGLE_MAPS_USAGE_LIMIT_MESSAGE = 'Google Maps usage limit exceeded';

export type GoogleMapsFailureReason = 'over_query_limit';

export function getGoogleMapsFailureReason(error: unknown): GoogleMapsFailureReason | undefined {
  return (error as { code?: unknown } | null | undefined)?.code === 'OVER_QUERY_LIMIT' ? 'over_query_limit' : undefined;
}
